import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/AccountsAPI/verifyTermLoanAPI';

const err = (e, fallback) => e?.ErrorDetails?.ErrorMessage || e?.Message || e?.message || fallback;

export const fetchVerifyTermLoanQueue = createAsyncThunk(
    'verifyTermLoan/fetchQueue',
    async (roleId, { rejectWithValue }) => {
        try { return await api.getVerificationTermLoans(roleId); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch term loan verification queue')); }
    }
);

export const fetchVerifyTermLoanDetail = createAsyncThunk(
    'verifyTermLoan/fetchDetail',
    async (rowId, { rejectWithValue }) => {
        try { return await api.getTermLoanById(rowId); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch term loan details')); }
    }
);

export const submitVerifyTermLoan = createAsyncThunk(
    'verifyTermLoan/verify',
    async (payload, { rejectWithValue }) => {
        try { return await api.verifyTermLoan(payload); }
        catch (e) { return rejectWithValue(err(e, 'Error Occurred While Verification')); }
    }
);

const initialState = {
    queue: [], queueLoading: false, queueError: null,
    detail: null, detailLoading: false, detailError: null,
    verifyLoading: false,
};

const firstRow = (data) => (Array.isArray(data) ? data[0] || null : data || null);

const verifyTermLoanSlice = createSlice({
    name: 'verifyTermLoan',
    initialState,
    reducers: {
        clearVerifyTermLoanDetail: (s) => { s.detail = null; s.detailError = null; s.detailLoading = false; },
        resetVerifyTermLoan: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVerifyTermLoanQueue.pending, (s) => { s.queueLoading = true; s.queueError = null; })
            .addCase(fetchVerifyTermLoanQueue.fulfilled, (s, a) => { s.queueLoading = false; s.queue = a.payload?.Data || []; })
            .addCase(fetchVerifyTermLoanQueue.rejected, (s, a) => { s.queueLoading = false; s.queueError = a.payload; s.queue = []; });

        builder
            .addCase(fetchVerifyTermLoanDetail.pending, (s) => { s.detailLoading = true; s.detailError = null; s.detail = null; })
            .addCase(fetchVerifyTermLoanDetail.fulfilled, (s, a) => { s.detailLoading = false; s.detail = firstRow(a.payload?.Data); })
            .addCase(fetchVerifyTermLoanDetail.rejected, (s, a) => { s.detailLoading = false; s.detailError = a.payload; s.detail = null; });

        builder
            .addCase(submitVerifyTermLoan.pending, (s) => { s.verifyLoading = true; })
            .addCase(submitVerifyTermLoan.fulfilled, (s) => { s.verifyLoading = false; })
            .addCase(submitVerifyTermLoan.rejected, (s) => { s.verifyLoading = false; });
    },
});

export const { clearVerifyTermLoanDetail, resetVerifyTermLoan } = verifyTermLoanSlice.actions;

export const selectVTLQueue = (s) => s.verifyTermLoan.queue;
export const selectVTLQueueLoading = (s) => s.verifyTermLoan.queueLoading;
export const selectVTLQueueError = (s) => s.verifyTermLoan.queueError;
export const selectVTLDetail = (s) => s.verifyTermLoan.detail;
export const selectVTLDetailLoading = (s) => s.verifyTermLoan.detailLoading;
export const selectVTLDetailError = (s) => s.verifyTermLoan.detailError;
export const selectVTLVerifyLoading = (s) => s.verifyTermLoan.verifyLoading;

export default verifyTermLoanSlice.reducer;
